import { selectFromProjectSubscription } from '../models';
import ProjectPendingSolutionQuery from '../queries/projects/ProjectPendingSolutionQuery';
import { SubscriptionHandler } from '../utils/createSubscription';
import projectRouteDeletedHandler from './handlers/projectRouteDeletedHandler';
import projectRouteAddedHandler from './handlers/projectRouteAddedHandler';
import projectRouteUpdatedHandler from './handlers/projectRouteUpdatedHandler';
import projectVisitGeocodedHandler from './handlers/projectVisitGeocodedHandler';
import projectRouteStopScheduledHandler from './handlers/projectRouteStopScheduledHandler';
import projectRouteStopSchedulingHandler from './handlers/projectRouteStopSchedulingHandler';
import projectStopUnschedulingHandler from './handlers/projectStopUnschedulingHandler';
import projectStopUnscheduledHandler from './handlers/projectStopUnscheduledHandler';
import projectStopReschedulingHandler from './handlers/projectStopReschedulingHandler';
import projectStopRescheduledHandler from './handlers/projectStopRescheduledHandler';
import projectDispatchedRoutesHandler from './handlers/projectDispatchedRoutesHandler';
import projectUnscheduledStopsDeletedHandler from './handlers/projectUnscheduledStopsDeletedHandler';
import projectUnscheduledStopsUpdatedHandler from './handlers/projectUnscheduledStopsUpdatedHandler';
import projectStopsUnscheduledHandler from './handlers/projectStopsUnscheduledHandler';
import projectStopsScheduledHandler from './handlers/projectStopsScheduledHandler';
import projectStopsSchedulingFailedHandler from './handlers/projectStopsSchedulingFailedHandler';
import projectCountUpdatedHandler from './handlers/projectCountUpdatedHandler';

const selector = selectFromProjectSubscription()
  .projectDeletedDto(b => b.project(p => p.id.name.deleted))
  .projectRouteDeletedDto(b => b.routeId.name)
  .projectRouteAddedDto(b => b.routeId.name)
  .projectRouteUpdatedDto(b => b.routeId.name)
  .projectRouteStopSchedulingDto(b => b.pendingSolution(b => b.projectId.actionType.assignAction(b => b.targetRouteId.targetRouteName.visitId.visitName.originRouteId)))
  .projectRouteStopScheduledDto(b => b.pendingSolution(b => b.projectId.actionType.assignAction(b => b.targetRouteId.targetRouteName.visitId.visitName)).status)
  .projectVisitGeocodedDto(b => b.remaining)
  .projectRouteStopMovingDto(b => b.pendingSolution(p => p.projectId.actionType.assignAction(a => a.targetRouteName.targetRouteId.visitName.visitId.moveStopTargetIndex)))
  .projectRouteStopMovedDto(b => (
    b.pendingSolution(p => p.projectId.actionType.assignAction(a => a.targetRouteName.targetRouteId.visitName.visitId.moveStopTargetIndex.originRouteId))).success)
  .projectStopUnschedulingDto(b => b.pendingSolution(p => p.projectId.actionType.assignAction(a => a.targetRouteId.targetRouteName.visitId.visitName)))
  .projectStopUnscheduledDto(b => b.pendingSolution(p => p.projectId.actionType.assignAction(a => a.targetRouteId.targetRouteName.visitId.visitName)).success)
  .projectStopsUnscheduledDto(b => b.visitIds)
  .projectStopReschedulingDto(b => b.pendingSolution(s => s.projectId.actionType.assignAction(a => a.targetRouteId.targetRouteName.visitId.visitName)))
  .projectStopRescheduledDto(b => b.pendingSolution(s => s.projectId.actionType.assignAction(a => a.targetRouteId.targetRouteName.visitId.visitName)).success)
  .projectDispatchedRoutesDto(b => b.dispatchedCount)
  .projectUnscheduledStopsDeletedDto(b => b.projectId.deletedVisits(dv => dv.id.uuid.eventUuid))
  .projectUnscheduledStopsBulkUpdatedDto(b => b.projectId.updatedVisitIds(uv => uv.id.uuid.eventUuid))
  .projectStopsSchedulingDto(b => b.pendingSolution(ProjectPendingSolutionQuery))
  .projectStopsScheduledDto(b => b.pendingSolution(ProjectPendingSolutionQuery))
  .projectStopsSchedulingFailedDto(b => b.pendingSolution(ProjectPendingSolutionQuery))
  .toString();

export default (): SubscriptionHandler => ({
  name: 'ProjectSubscription',
  selector,
  events: new Map(Object.entries({
    ProjectDeletedDto: [projectCountUpdatedHandler],
    ProjectRouteDeletedDto: [projectRouteDeletedHandler],
    ProjectRouteAddedDto: [projectRouteAddedHandler],
    ProjectRouteUpdatedDto: [projectRouteUpdatedHandler],
    ProjectVisitGeocodedDto: [projectVisitGeocodedHandler],
    ProjectRouteStopSchedulingDto: [projectRouteStopSchedulingHandler],
    ProjectRouteStopScheduledDto: [projectRouteStopScheduledHandler],
    ProjectStopUnschedulingDto: [projectStopUnschedulingHandler],
    ProjectStopUnscheduledDto: [projectStopUnscheduledHandler],
    ProjectStopsUnscheduledDto: [projectStopsUnscheduledHandler],
    ProjectStopReschedulingDto: [projectStopReschedulingHandler],
    ProjectStopRescheduledDto: [projectStopRescheduledHandler],
    ProjectDispatchedRoutesDto: [projectDispatchedRoutesHandler],
    ProjectUnscheduledStopsDeletedDto: [projectUnscheduledStopsDeletedHandler],
    ProjectUnscheduledStopsBulkUpdatedDto: [projectUnscheduledStopsUpdatedHandler],
    ProjectStopsScheduledDto: [projectStopsScheduledHandler],
    ProjectStopsSchedulingFailedDto: [projectStopsSchedulingFailedHandler],
  })),
  onError(error: Error) {
    console.error('ProjectSubscription Error, check if websocket client initialized', JSON.stringify(error));

  },
});
